module.exports = __webpack_public_path__ + "img/107041.ffc450ab.png";